<template>
  <div class='b-fbl-loader'>
    <div
      v-for='i in isMobile ? 3 : 10'
      :key='i'
      class='item'
    >
      <div class='photo' />
      <div class='content'>
        <div class='line is-head' />
        <div class='line' />
        <div class='line is-short' />
        <div class='line is-thick is-short' />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  inheritAttrs: false
};
</script>

<script setup>
defineProps({
  isMobile: { type: Boolean, required: true }
});
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/responsive'

=fbl
  background: var(--fbl-loader-background)
  border-radius: var(--fbl-border-radius)

.b-fbl-loader
  gap: 0

.item
  border-top: 1px solid var(--gray-300)
  flex-direction: row
  position: relative

  +lte_ipad
    gap: rem4(16px)
    padding: rem4(19px) 0

  +gte_laptop
    align-items: center
    gap: 24px
    padding: rem4(19px) 0

.content
  display: flex
  flex-direction: column
  flex-grow: 1

  +lte_ipad
    gap: rem4(12px)

  +gte_laptop
    gap: 12px

.photo
  +fbl

  +lte_ipad
    height: rem4(90px)
    width: rem4(90px)

  +gte_laptop
    height: 90px
    width: 90px

.line
  +fbl

  +lte_ipad
    height: rem4(12px)
    width: rem4(190px)

  +gte_laptop
    height: 14px
    width: 215px

  &.is-head
    +lte_ipad
      height: rem4(14px)
      width: rem4(145px)

    +gte_laptop
      height: 16px
      width: 160px

  &.is-short
    +lte_ipad
      width: rem4(110px)

    +gte_laptop
      width: 120px

  &.is-thick
    +lte_ipad
      height: rem4(32px)

    +gte_laptop
      height: 30px

  &:not(.is-short):not(:last-child)
    +lte_ipad
      margin-bottom: rem4(4px)

    +gte_laptop
      margin-bottom: 4px
</style>
